import { render, staticRenderFns } from "./publicHome.vue?vue&type=template&id=9616a196"
import script from "./publicHome.vue?vue&type=script&lang=js"
export * from "./publicHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports